$(function () {
    const sections = $('.section-busines-overview');
    sections.each(resizeIframe);
    
    $(window).on('resize', () => sections.each(resizeIframe));

    function resizeIframe () {
        const iframe = $(this).find('iframe');

        if ($(this).hasClass('slide-content') && window.innerWidth >= 1020) initStickyContent(this);

        if (iframe[0]) {
            const height = iframe.attr('height');
            const width = iframe.attr('width');
            const aspectRatio = width / height;
            const innerWidth = iframe.innerWidth();
            iframe.attr('width', Math.round(innerWidth));
            iframe.attr('height', Math.round(innerWidth / aspectRatio));
        }
    }

    function initStickyContent(context) {
		const SECTION = $(context);
		const ITEMS = SECTION.find('.busines-overview-content__item');
		const FIRST_ITEM_HEIGHT = $(ITEMS.get(0)).outerHeight();
		const SECOND_ITEM_HEIGHT = $(ITEMS.get(1)).outerHeight();
		const INDEX = FIRST_ITEM_HEIGHT >= SECOND_ITEM_HEIGHT ? 1 : 0;

		$(ITEMS.get(INDEX)).find('.content').addClass('fixed');
		SECTION.find('.busines-overview-content ').css({alignItems: 'stretch'});
	}
});
